export default {"src":"/_next/static/media/mentor.12130096.svg","height":1200,"width":1600};